module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog modal-lg carrier-account\"> <div class=\"modal-content\"> <section class=\"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span></button> <h3>")
    ; __append(escapeFn( locals.readable ))
    ; __append(" Account</h3> </section> <form class=\"form-horizontal\"> <section class=\"modal-body\"> <div class=\"form-group\"> <label class=\"col-sm-4\" for=\"carrier_account_id\">ID</label> <div class=\"col-sm-8\" id=\"carrier_account_id\" name=\"carrier_account_id\">")
    ; __append(escapeFn( locals.id ))
    ; __append("</div> </div> <div class=\"form-group\"> <label class=\"col-sm-4 control-label\" for=\"carrier_account_reference\">Reference</label> <div class=\"col-sm-8\"> <input class=\"form-control\" id=\"carrier_account_reference\" name=\"carrier_account_reference\" type=\"text\" value=\"")
    ; __append(escapeFn( locals.reference ))
    ; __append("\" ")
    ; __append(escapeFn( (locals.reference ? 'disabled="disabled"' : '') ))
    ; __append(" placeholder=\"(Optional) Enter a custom reference. This cannot be edited once set.\"> </div> </div> <div class=\"form-group\"> <label class=\"col-sm-4 control-label\" for=\"carrier_account_description\">Description</label> <div class=\"col-sm-8\"> <input class=\"form-control\" id=\"carrier_account_description\" name=\"carrier_account_description\" type=\"text\" value=\"")
    ; __append(escapeFn( locals.description ))
    ; __append("\" placeholder=\"Please enter a custom description for future reference\"> </div> </div> ")
    ;  if (locals.hasCredentials) { 
    ; __append(" <hr> <div id=\"credential_management\"></div> ")
    ;  } 
    ; __append(" ")
    ;  if (locals.hasTestCredentials) { 
    ; __append(" <hr> <div id=\"test_credential_management\"></div> ")
    ;  } 
    ; __append(" </section> <section class=\"modal-footer\"> <button class=\"btn btn-red cancel\" type=\"button\">Cancel</button> <button class=\"btn btn-blue update_account\" type=\"submit\">Update</button> </section> </form> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/carrier_account_details_modal.ejs
// module id = 872
// module chunks = 1